import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { LoginService } from '@serengeti/serengeti-common';
import { LocaleService } from './locale.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-member-locale',
	templateUrl: './locale.component.html',
	styleUrls: ['./locale.component.scss']
})
export class LocaleComponent implements OnInit {

	@Input() value: any;
	@Input() returnUrl: string;

	locales: any[];

	theme;
	menuNavigation: any;

	constructor(
		private router: Router,
		private localeService: LocaleService,
		private loginService: LoginService,
		private translateService: TranslateService,
	) {
		this.locales = localeService.locales;
		if (!this.value) {
			const loginSession = this.loginService.loadLoginSession();

			if (loginSession) {
				this.value = loginSession.locale;
			} else {
				this.value = this.translateService.currentLang;

				if (!this.value) {
					this.value = 'ko-kr';
				}
			}
		}
		this.theme = localStorage;
		this.menuNavigation = environment.menuNavigation;
	}

	ngOnInit() {
	}

	public changeLocale() {
		this.localeService.changeLocales(this.value);
		if (this.returnUrl) {
			this.router.navigateByUrl(this.router.url + "?returnUrl=" + this.returnUrl);
		} else {
			this.router.navigateByUrl(this.router.url);
		}
	}
	
}
